import React from "react";

import HootsuiteLogo from "../../../assets/images/png/partner-logo/Hootsuite.png";
import UberLogo from "../../../assets/images/png/partner-logo/Uber.png";
import AmazonLogo from "../../../assets/images/png/partner-logo/amazon.webp";
import BoltLogo from "../../../assets/images/png/partner-logo/bolt.png";
import BundleLogo from "../../../assets/images/png/partner-logo/bundle.png";
import CapitalOneLogo from "../../../assets/images/png/partner-logo/capitalOne.png";
import FacebookLogo from "../../../assets/images/png/partner-logo/facebook.webp";
import GoogleLogo from "../../../assets/images/png/partner-logo/google.jpg";
import KPMGLogo from "../../../assets/images/png/partner-logo/kpmg.png";
import MacdonaldLogo from "../../../assets/images/png/partner-logo/macdonald.png";
import MastercardLogo from "../../../assets/images/png/partner-logo/mastercard.webp";
import PwCLogo from "../../../assets/images/png/partner-logo/pwc.png";
import SamsungLogo from "../../../assets/images/png/partner-logo/samsung.png";
import SAPLogo from "../../../assets/images/png/partner-logo/sap.png";
import ShopifyLogo from "../../../assets/images/png/partner-logo/shopify.png";
import SlackLogo from "../../../assets/images/png/partner-logo/slack.png";
import SquareLogo from "../../../assets/images/png/partner-logo/square.png";
import StripeLogo from "../../../assets/images/png/partner-logo/stripe.png";
import TiktokLogo from "../../../assets/images/png/partner-logo/tiktok.png";

import * as Animate from "react-reveal";
import useSelectedLocation from "../../../helpers/useSelectedLocation";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

const ImageCard = ({ image }) => (
  <div className="relative w-full h-16 object-contain">
    <img
      src={image || BundleLogo}
      className="w-24 h-14 object-contain"
      alt=""
    />
  </div>
);

const OtherCountries = () => {
  return (
    <Animate.Fade bottom>
      <ImageCard image={SlackLogo} />
      <ImageCard image={FacebookLogo} />
      <ImageCard image={CapitalOneLogo} />
      <ImageCard image={GoogleLogo} />
      <ImageCard image={AmazonLogo} />
      <ImageCard image={SamsungLogo} />
      <ImageCard image={ShopifyLogo} />
      <ImageCard image={SquareLogo} />
      <ImageCard image={UberLogo} />
      <ImageCard image={TiktokLogo} />
      <ImageCard image={MastercardLogo} />
      <ImageCard image={MacdonaldLogo} />
      <ImageCard image={PwCLogo} />
      <ImageCard image={SAPLogo} />
      <ImageCard image={HootsuiteLogo} />
      <ImageCard image={KPMGLogo} />
      <ImageCard image={StripeLogo} />
      <ImageCard image={BoltLogo} />
    </Animate.Fade>
  );
};

const PartnersLogoSlider = ({ children }) => {
  return (
    <div className="block md:hidden">
      <OwlCarousel
        className="owl-carousel owl-theme"
        items={3}
        loop={true}
        autoplay={true}
        autoplayTimeout={2000}
        nav={false}
        dots={false}
        margin={28}
        stageClass="pt-5"
        responsiveClass={true}
        responsive={{
          0: {
            items: 3,
            nav: false,
          },
          600: {
            items: 3,
            nav: false,
          },
          1000: {
            items: 5,
            nav: false,
            loop: false,
          },
        }}
      >
        {children}
      </OwlCarousel>
    </div>
  );
};

const TalentWorkSection = ({ showNews = true }) => {
  const selectedLocation = useSelectedLocation();
  return (
    <section className="pt-16 lg:pt-20 pb-20">
      <div className="container mx-auto px-4">
        <div className="mb-6 lg:mb-8">
          <Animate.Fade bottom>
            <p className="text-default text-lg font-mono font-medium">
              Our Talents Work With Many of these Leading Tech Companies
            </p>
          </Animate.Fade>
        </div>

        {/* <PartnersLogoSlider /> */}

        {selectedLocation?.name === "Africa" || !selectedLocation ? (
          <>
            {/* Mobile Only */}
            <PartnersLogoSlider>
              <OtherCountries />
            </PartnersLogoSlider>

            {/* Desktop Only */}
            <div className="hidden md:grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-x-8 gap-y-6 mx-auto items-center justify-center partners-logo-wrapper">
              <OtherCountries />
            </div>
          </>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-x-8 gap-y-6 mx-auto items-center justify-center partners-logo-wrapper">
            <OtherCountries />
          </div>
        )}
      </div>
    </section>
  );
};

export default TalentWorkSection;
